import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import action from 'ReduxModules/action';
import Faq from '../../assets/svg/faq';
import Operation from '../../assets/svg/operation';
import Feedback from '../../assets/svg/feedback_new';
import global from '../../common/global';
import ajax from "../util/ajax";
import './style.module.scss';
import { historyPush } from "../util/publish";

const SKILLS_LIST = '/customer/articleList.do';
const TOPIC_ID = '00019AD6';
const SIZE = 3;
class Home extends PureComponent {
  state = {
    total: 0,
    pageNo: 1,
    list: [],
    loading: false,
  };

  componentDidMount() {
    this.updateData({
      pageNo: this.state.pageNo,
    });
  }

  openQiyu = () => {
    const { stone = {}, updateCommon } = this.props;
    if (stone.user && stone.user.wemediaId) {
      let param = {
        uid: stone.user.tid || '',
        name: stone.user.tname,
        robotShuntSwitch: 1, // 申请人工客服之前是否先申请机器人开关，0代表关闭，1代表启用。
        level: `${stone.user.accountQuality}`,
        data: JSON.stringify([
          {
            key: 'star',
            label: '星级',
            value: global.getLabelByValue('star', stone.user.star),
          },
          {
            key: 'accountQuality',
            label: '图文质量',
            value: global.getLabelByValue('accountLevelType', stone.user.accountQuality),
          },
          {
            key: 'videoQuality',
            label: '视频质量',
            value: global.getLabelByValue('accountLevelType', stone.user.videoQuality),
          },
          {
            key: 'authority',
            label: '运营权限',
            value: global.getLabelByValue('authority', stone.user.local),
          },
          {
            key: 'accountType',
            label: '账号类型',
            value: global.getLabelByValue('accountType', stone.user.accountType),
          },
        ]),
      };
      // 账号类型为自媒体且图文质量为中等、差、未审核、待定的用户，默认接入机器人，转人工时，接入空客服组，进入留言模式
      if (stone.user.accountType === 1 && [0, 1, 2, 5].indexOf(stone.user.accountQuality) !== -1) {
        param = Object.assign({}, param, { groupid: '398004088' });
      }
      window.ysf.on({
        onload: () => {
          window.ysf.config(param);
        },
      });
      window.ysf.open();
    } else {
      return ajax('/navinfo.do', {}, rs => {
        updateCommon('user', rs.data);
        return rs;
      });
    }
  };

  updateData = (params = {}) => {
    this.setState({
      loading: true,
    });
    return ajax(
      SKILLS_LIST,
      {
        method: 'post',
        data: {
          size: SIZE,
          topicId: TOPIC_ID,
          ...params,
        },
      },
      newData => {
        if (newData && newData.data) {
          this.setState({
            list: newData.data.list,
            total: newData.data.total,
          });
        }
      },
    ).then(() => {
      this.setState({
        loading: false,
      });
    });
  };

  handleSearch = e => {
    if (e.key === 'Enter') {
      this.handleClick();
    }
  };

  handleClick = () => {
    const word = this.input.state.value;
    window.location.href = `/customer.html#/details/faq?word=${word}`;
  };

  render() {
    const isMp = /^(mp|predy\d*).163.com/.test(window.location.host);

    return (
      <main>
        <h1 styleName="home-title">网易号客服中心</h1>
        {/* <div className="search-bar"> */}
        {/*  <Input */}
        {/*    size="large" */}
        {/*    showDeleteBtn */}
        {/*    placeholder="请输入关键词进行搜索" */}
        {/*    className="search-input" */}
        {/*    onKeyPress={this.handleSearch} */}
        {/*    ref={input => (this.input = input)} */}
        {/*  /> */}
        {/*  <Button className="search-btn" type="primary" onClick={this.handleClick} size="large"> */}
        {/*    搜索 */}
        {/*  </Button> */}
        {/* </div> */}
        <nav>
          <ul styleName="entrance-list main-entrances">
            <li>
              <a href={`//${window.location.host}/college.html?wemediaId=W1686582682210028374#/guidence/hot/account`} styleName="entrance">
                <div styleName="entrance-icon">
                  <Faq />
                </div>
                <div styleName="entrance-title">常见问题</div>
                <div styleName="entrance-desc">简单问题自助快速解决</div>
              </a>
            </li>
            <li>
              <a href={`//${window.location.host}/college.html?wemediaId=W1686582682210028374#/courseshare`} styleName="entrance">
                <div styleName="entrance-icon">
                  <Operation />
                </div>
                <div styleName="entrance-title">运营技巧</div>
                <div styleName="entrance-desc">实用技巧一网打尽</div>
              </a>
            </li>
            <li>
              <a
                onClick={() => {
                  // const { history } = this.props;
                  // historyPush(history, '/details/feedback');
                  window.open('https://mp.163.com/subscribe_v4/index.html#/layout/ai-customer-service')
                }}
                href="javascript:;"
                styleName="entrance">
                <div styleName="entrance-icon">
                  <Feedback />
                </div>
                <div styleName="entrance-title">意见反馈</div>
                <div styleName="entrance-desc">24小时在线倾听您的反馈</div>
              </a>
            </li>
            {/* <li>
              <div styleName="entrance" onClick={this.openQiyu} style={{ cursor: 'pointer' }}>
                <div styleName="entrance-icon">
                  <CustomerService />
                </div>
                <div styleName="entrance-title">在线客服</div>
                <div styleName="entrance-desc">官方客服解答疑难问题</div>
              </div>
            </li> */}
          </ul>
        </nav>
        {/* <section> */}
        {/*  <h1 styleName="subtitle">常见问题</h1> */}
        {/*  <ul styleName="entrance-list"> */}
        {/*    <li> */}
        {/*      <Link to="/details/faq?topicId=00019AD7" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <HotQuestion /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">热门问题</div> */}
        {/*      </Link> */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      <Link to="/details/faq?topicId=00019AD9" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <AboutAccount /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">帐号相关</div> */}
        {/*      </Link> */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      <Link to="/details/faq?topicId=00019ADF" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <ContentCreation /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">内容创作</div> */}
        {/*      </Link> */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      <Link to="/details/faq?topicId=00019CI1" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <Violation /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">违规处罚</div> */}
        {/*      </Link> */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      <Link to="/details/faq?topicId=00019ADS" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <StarIndex /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">帐号功能</div> */}
        {/*      </Link> */}
        {/*    </li> */}
        {/*    /!* <li> */}
        {/*      <Link to="/details/faq?topicId=00019AE0" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <Signing /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">特色签约</div> */}
        {/*      </Link> */}
        {/*    </li> *!/ */}
        {/*    <li> */}
        {/*      <Link to="/details/faq?topicId=00019AE2" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <Cooperation /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">合作洽谈</div> */}
        {/*      </Link> */}
        {/*    </li> */}
        {/*    <li> */}
        {/*      <Link to="/details/faq?topicId=00019ADO" styleName="entrance"> */}
        {/*        <div styleName="entrance-icon"> */}
        {/*          <Income /> */}
        {/*        </div> */}
        {/*        <div styleName="entrance-title">收益相关</div> */}
        {/*      </Link> */}
        {/*    </li> */}
        {/*  </ul> */}
        {/*  <div styleName="all-link"> */}
        {/*    <Link to="/details/faq">全部常见问题 ></Link> */}
        {/*  </div> */}
        {/* </section> */}
        {/* <section> */}
        {/*  <h1 styleName="subtitle">运营技巧</h1> */}
        {/*  <ul styleName="entrance-list"> */}
        {/*    {this.state.list.map((article, index) => { */}
        {/*      const { docid, title, body = '' } = article; */}
        {/*      const articlePcPage = isMp */}
        {/*        ? `//dy.163.com/article/${docid}.html` */}
        {/*        : `/article/${docid}.html`; */}
        {/*      return ( */}
        {/*        <li key={index} styleName="summary"> */}
        {/*          <a */}
        {/*            href={articlePcPage || ''} */}
        {/*            target="_blank" */}
        {/*            rel="noopener noreferrer" */}
        {/*            styleName="skill"> */}
        {/*            <article> */}
        {/*              <h1>{title}</h1> */}
        {/*              <p>{body.replace(/<\/?.+?>/g, '')}</p> */}
        {/*            </article> */}
        {/*          </a> */}
        {/*        </li> */}
        {/*      ); */}
        {/*    })} */}
        {/*  </ul> */}
        {/*  <div styleName="all-link"> */}
        {/*    <Link to="/details/skill">全部运营技巧 ></Link> */}
        {/*  </div> */}
        {/* </section> */}
      </main>
    );
  }
}

export default connect(
  state => ({
    stone: state.common,
    router: state.router,
  }),
  dispatch =>
    bindActionCreators(
      {
        updateCommon: action.updateCommon,
      },
      dispatch,
    ),
)(withRouter(Home));
